import { render } from "./CustomerReturns.vue?vue&type=template&id=8d8ea8da&scoped=true"
import script from "./CustomerReturns.vue?vue&type=script&lang=js"
export * from "./CustomerReturns.vue?vue&type=script&lang=js"

import "./CustomerReturns.vue?vue&type=style&index=0&id=8d8ea8da&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8ea8da"]])

export default __exports__